import { Component, ViewEncapsulation } from '@angular/core';


@Component({
	selector: 'lb-form-field',
	standalone: true,
	imports: [],
	template: '<ng-content></ng-content>',
	styleUrl: './form-field.component.scss',
	encapsulation: ViewEncapsulation.None
})
export class FormFieldComponent {}
